import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Card, Divider, message, Spin } from 'antd';
import { fetchPaymentSettings, savePaymentSettings } from '../api';
// import { fetchPaymentSettings, savePaymentSettings } from '../api/payments';

const { Option } = Select;

const PaymentSettingsForm = ({ farmId }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const data = await fetchPaymentSettings(farmId);
                form.setFieldsValue(data);
            } catch (err) {
                message.error('Failed to load payment settings');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [farmId]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            setSaving(true);
            await savePaymentSettings(farmId, values);
            message.success('Payment settings saved');
        } catch (err) {
            if (err?.errorFields) return;
            message.error(err.response?.data?.error || 'Failed to save settings');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <Spin />;

    return (
        <Card title="Payment Integration Settings">
            <Form form={form} layout="vertical">
                <Divider orientation="left">M-Pesa (Daraja)</Divider>
                <Form.Item name="mpesaEnvironment" label="Environment">
                    <Select>
                        <Option value="sandbox">Sandbox</Option>
                        <Option value="production">Production</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="mpesaShortcode" label="Shortcode / Paybill">
                    <Input placeholder="e.g. 174379" />
                </Form.Item>
                <Form.Item name="mpesaConsumerKey" label="Consumer Key">
                    <Input.Password placeholder="Enter to update, leave masked to keep existing" />
                </Form.Item>
                <Form.Item name="mpesaConsumerSecret" label="Consumer Secret">
                    <Input.Password placeholder="Enter to update, leave masked to keep existing" />
                </Form.Item>
                <Form.Item name="mpesaPasskey" label="Passkey">
                    <Input.Password placeholder="Enter to update, leave masked to keep existing" />
                </Form.Item>

                <Divider orientation="left">KRA eTIMS</Divider>
                <Form.Item name="etimsEnvironment" label="Environment">
                    <Select>
                        <Option value="sandbox">Sandbox</Option>
                        <Option value="production">Production</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="etimsBaseUrl" label="eTIMS API Base URL">
                    <Input placeholder="https://etims-sbx.kra.go.ke" />
                </Form.Item>
                <Form.Item name="etimsDeviceSerial" label="Device Serial">
                    <Input.Password placeholder="Enter to update, leave masked to keep existing" />
                </Form.Item>
                <Form.Item name="etimsPin" label="KRA PIN">
                    <Input.Password placeholder="Enter to update, leave masked to keep existing" />
                </Form.Item>

                <Button type="primary" onClick={handleSave} loading={saving}>
                    Save Settings
                </Button>
            </Form>
        </Card>
    );
};

export default PaymentSettingsForm;